import { forwardRef, useEffect, useState } from "react";
import { ko } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface ICustomDatePicker {
    onChange: (value: Date | [Date | null, Date | null] | null) => void;
    isReset?: boolean
    setIsReset?: React.Dispatch<React.SetStateAction<boolean>>
    isRange?: boolean
    isMinToday?: boolean
    isMaxToday?: boolean
    disabled?: boolean
    height?: string
    value?: string
    width?: string
    text?: string
}

const CustomDatePicker = forwardRef<DatePicker, ICustomDatePicker>(
    (
        {
            isReset,
            setIsReset,
            onChange,
            isRange = false,
            isMinToday,
            isMaxToday,
            disabled = false,
            text,
            width,
            height,
            value,
        },
        ref
    ) => {
        type SingleValue = Date | null;
        type RangeValue = [Date | null, Date | null];

        const [startDate, setStartDate] = useState<Date | null>(null);
        const [endDate, setEndDate] = useState<Date | null>(null);

        useEffect(() => {
            if (isReset) {
                setStartDate(null)
                setEndDate(null)
                setIsReset?.(false)
            }
        }, [isReset])

        const handleChange = (value: SingleValue | RangeValue) => {
            if (isRange && Array.isArray(value)) {
                const [start, end] = value;
                setStartDate(start);
                setEndDate(end);
                onChange([start, end]);
            }
            else if (!isRange && value instanceof Date) {
                setStartDate(value);
                onChange(value);
            }
            else {
                // 값이 null일 수도 있으니 처리
                onChange(value);
            }
        };

        const formatInputDate = (input: string, isMinToday?: boolean, isMaxToday?: boolean): Date | null => {
            // 숫자만 추출
            const digits = input?.replace(/\D/g, '');

            if (digits?.length === 8) {
                const year = parseInt(digits.slice(0, 4), 10);
                const month = parseInt(digits.slice(4, 6), 10) - 1;
                const day = parseInt(digits.slice(6, 8), 10);
                let date = new Date(year, month, day);
                const today = new Date();
                if (isMinToday && date < today) {
                    date = today;
                }
                if (isMaxToday && date > today) {
                    date = today;
                }
                return date;
            }
            return null;
        };

        return (
            <div className="w-full">
                <DatePicker
                    ref={ref}
                    className={`bg-[#F8F8FA] px-6 rounded-lg border border-transparent hover:border-[#B3B3B3] 
                    ${height ? `h-${height}` : 'h-15'} 
                    ${width ? `w-${width}` : 'w-[320px]'} 
                    ${text ? `text-${text}` : 'text-sm'}
                    tablet:h-10 tablet:w-full
                    disabled:bg-[#9D9EB7] disabled:text-white`}
                    onChange={handleChange}
                    calendarClassName="rounded-lg shadow-lg border"
                    locale={ko}
                    disabled={disabled}
                    popperPlacement="bottom"
                    popperModifiers={[
                        {
                            name: 'remove-flip',
                            fn: () => ({ reset: { placement: 'bottom', rects: true } })
                        }
                    ]}
                    onChangeRaw={(event) => {
                        if (!event) return
                        if (isRange) return
                        const target = event.target as HTMLInputElement;
                        const inputValue = target.value;

                        const parsedDate = formatInputDate(inputValue, isMinToday, isMaxToday);
                        if (parsedDate) handleChange(parsedDate);
                    }}
                    dateFormat="yyyy-MM-dd"
                    rangeSeparator=" ~ "
                    placeholderText={isRange ? "YYYY-MM-DD ~ YYYY-MM-DD" : "YYYY-MM-DD"}
                    minDate={isMinToday ? new Date() : undefined}
                    maxDate={isMaxToday ? new Date() : undefined}
                    {...(isRange
                        ? {
                            selectsRange: true,
                            startDate,
                            endDate,
                        }
                        : {
                            selected: startDate,
                        })}
                // renderCustomHeader={({
                //     date,
                //     changeYear,
                //     changeMonth,
                //     decreaseMonth,
                //     increaseMonth,
                //     prevMonthButtonDisabled,
                //     nextMonthButtonDisabled
                // }) => (
                //     <div
                //         className="flex justify-center items-center gap-4 bg-primary h-10"
                //     >
                //         {/* 년 먼저 */}
                //         <select
                //             value={date.getFullYear()}
                //             onChange={({ target: { value } }) => changeYear(Number(value))}
                //         >
                //             {Array.from(
                //                 { length: 10 },
                //                 (_, i) => date.getFullYear() - 5 + i
                //             ).map((year) => (
                //                 <option key={year} value={year}>
                //                     {year}년
                //                 </option>
                //             ))}
                //         </select>

                //         {/* 월 */}
                //         <select
                //             value={date.getMonth()}
                //             onChange={({ target: { value } }) => changeMonth(Number(value))}
                //         >
                //             {Array.from({ length: 12 }, (_, i) => i).map((month) => (
                //                 <option key={month} value={month}>
                //                     {month + 1}월
                //                 </option>
                //             ))}
                //         </select>
                //     </div>
                // )}
                />
            </div>
        );
    }
)

export default CustomDatePicker;